/* eslint-disable jsx-a11y/iframe-has-title */
import { useEffect, useState, useMemo, useCallback, memo } from "react";
import { AccordionCustomIcon } from "../Accordian/Accordian";
import styles from "./TableofContent.module.css";
import CryptoJS from "crypto-js";
import "../../style.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import BunnyPlayer from "../BunnyPlayer/BunnyPlayer";

function TableofContent({
  handleSelectVideo,
  videoObj,
  handlePrevVideo,
  handleNextVideo,
  showContent,
  Videos,
  setTab,
  setIndex,
  index,
  tab,
  selectedVideo,
}) {
  const [link, setLink] = useState();
  const [params] = useSearchParams();

  // Memoize userData to avoid recalculating on every render
  const userData = useMemo(() => {
    const localData = localStorage.getItem("elmataryapp");
    const decryptedBytes = localData && CryptoJS.AES.decrypt(localData, "111");
    return decryptedBytes && JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
  }, []);

  const [player, setPlayer] = useState(2);

  useEffect(() => {
    if (videoObj?.bunny_url) {
      setPlayer(3);
    } else if (videoObj?.link_video && videoObj?.link_video?.length) {
      setPlayer(1);
    } else {
      setPlayer(2);
    }
  }, [videoObj]);
  console.log("videoObj", videoObj)

  // Memoize YouTube URL extraction
  const getYoutibeUrl = useCallback((youtube_id) => {
    if (youtube_id && youtube_id.length) {
      const regExp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = youtube_id.match(regExp);
      if (match && match[2].length === 11) {
        return match[2];
      }
    }
    return null;
  }, []);

  // Update link only when player or relevant videoObj properties change
  useEffect(() => {
    if (player === 1 && videoObj?.link_video) {
      const youtubeId = getYoutibeUrl(videoObj.link_video);
      setLink(youtubeId);
    } else if (player === 2 && videoObj?.loom_url) {
      setLink(videoObj.loom_url.split("share/")[1]);
    } else {
      setLink(undefined);
    }
  }, [player, videoObj?.link_video, videoObj?.loom_url, getYoutibeUrl]);
  const navigate = useNavigate();
  const [position, setPosition] = useState({
    top: "10px",
    left: "10px",
    opacity: 0.5,
  });
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    const updatePosition = () => {
      // Generate random positions within the bounds of the video frame
      const randomTop = Math.floor(Math.random() * 80) + "%";
      const randomLeft = Math.floor(Math.random() * 80) + "%";
      setPosition({ top: randomTop, left: randomLeft, opacity: 0.5 });
      const timeOut = setTimeout(() => {
        setPosition((prev) => ({ ...prev, opacity: 0 }));
      }, 2500);
      return () => clearTimeout(timeOut);
    };

    // Update position every 6 seconds
    const interval = setInterval(updatePosition, 6000);

    // Cleanup interval on component unmount
    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <div className="videoscolumnDiv">
      <div
        className={`${styles.container} my-8 videoContentTwo`}
        style={{ width: "100%", minHeight: "100vh" }}
      >
        <div className={styles.video + " showVideo"}>
          {player == 1 ? (
            <iframe
              // width="560"
              className="publitioPlaceHolder"
              height="415"
              src={`https://www.youtube.com/embed/${link}?autoplay=0&cc_lang_pref=en-GB&cc_load_policy=1&controls=2&rel=0&hl=en-GB&enablejsapi=1&origin=https%3A%2F%2Fsupport.google.com&widgetid=1&fs=1`}
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; allowfullscreen;fullscreen;"
              allowfullscreen
              onContextMenu={(e) => e.preventDefault()}
            ></iframe>
          ) : player == 2 ? (
            <>
              <span
                style={{
                  zIndex: "2900",
                  position: isFullScreen ? "fixed" : "absolute",
                  top: isFullScreen ? "10px" : "20px",
                  left: isFullScreen ? "10px" : "10px",
                  cursor: "pointer",
                }}
                onClick={() => setIsFullScreen(!isFullScreen)}
                className="btn btn-primary"
              >
                {isFullScreen ? (
                  <img
                    src="https://res.cloudinary.com/duovxefh6/image/upload/v1733829730/material-symbols-light--close-fullscreen-rounded_gssgwu.png"
                    alt=""
                    style={{
                      width: "20px",
                    }}
                  />
                ) : (
                  <img
                    src="https://res.cloudinary.com/duovxefh6/image/upload/v1733829262/solar--full-screen-bold-duotone_u9meum.png"
                    alt=""
                    style={{
                      width: "20px",
                    }}
                  />
                )}
              </span>
              <div
                className="videoTest"
                style={{
                  zIndex: "190",
                  position: "relative",
                }}
              >
                {/* <div
                className="student_id"
                style={{
                  position: "absolute",
                  top: position.top,
                  right: position.left,
                  transition: "top 0.5s, left 0.5s",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  color: "white",
                  padding: "5px",
                  borderRadius: "5px",
                }}
              >
                {userData?.student_id}
              </div> */}

                <iframe
                  className={`videoIframe ${isFullScreen ? "isFullScreen" : ""
                    }`}
                  src={"https://www.loom.com/embed/" + link}
                  // width="560"
                  height="415"
                  frameborder="0"
                  // webkitallowfullscreen
                  // mozallowfullscreen
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;web-share;"
                // allowfullscreen={true}
                ></iframe>
                <div
                  className="student_email"
                  style={{
                    position: "absolute",
                    top: position.top,
                    left: position.left,
                    transition: "top 0.5s, left 0.5s",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: position?.opacity,
                  }}
                >
                  {userData?.student_email}
                </div>
              </div>
            </>
          ) : player == 3 ? (
            <BunnyPlayer
              userEmail={userData?.student_email}
              key={videoObj?.bunny_url}
              src={videoObj?.bunny_url}
              title={videoObj?.video_title || videoObj?.title || videoObj?.name}
            />
          ) : null}
        </div>

        {showContent ? (
          <div className={`${styles.accordian}`}>
            <div className="progress-container" style={{ paddingLeft: "30px" }}>
              <span onClick={handlePrevVideo} className="handlePrevVideo">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6 my-auto"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
                  />
                </svg>
              </span>
              <div className="progressBar">
                <p style={{ fontWeight: "800" }}>{params.get("course_name")}</p>
                <div className="progress">
                  <span
                    style={{
                      width: params.get("r") + "%",
                      display: "block",
                    }}
                  ></span>
                </div>
                <p>
                  <span>Process</span>
                  <span>{params.get("r")}%</span>
                </p>
              </div>
              <span onClick={handleNextVideo}>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-6 h-6 my-auto"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
                  />
                </svg>
              </span>
            </div>
            <AccordionCustomIcon
              handleSelectVideo={handleSelectVideo}
              Videos={Videos}
              setTab={setTab}
              selectedVideo={selectedVideo}
              setIndex={setIndex}
              index={index}
              tab={tab}
              videoObj={videoObj}
            />
          </div>
        ) : null}
      </div>
      {/* <button
        onClick={() => {
          navigate("/videoquestions", {
            state: { video: videoObj },
          });
        }}
        style={{ marginRight: "4px", marginBottom:"20px", marginTop:"20px", color: "white" }}
        className="btn btn-warning"
      >
        questions
      </button> */}
    </div>
  );
}

export default memo(TableofContent);
